<template>
  <el-dialog
    top="50px"
    width="600px"
    :title="isCreate ? 'Thêm module mới' : 'Sửa module'"
    :visible="visible"
    :show-close="!callingAPI"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="12"
:span="24">
          <el-form-item
prop="key"
label="Mã module">
            <el-input
              v-model="form.key"
              :disabled="!isCreate"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:span="24">
          <el-form-item
prop="name"
label="Tên module">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:span="24">
          <el-form-item
prop="icon"
label="Icon hiển thị">
            <el-input
              v-model="form.icon"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="12"
:span="24">
          <el-form-item
prop="order"
label="STT module">
            <el-input-number
              v-model="form.order"
              class="w-100"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24"
class="mb-xl"
>
          <el-form-item
prop="groups"
label="Nhóm hiển thị"
class="mb-s"
>
            <el-select
              v-model="form.groups"
              placeholder="Chọn nhóm"
              multiple
              cleable
              filterable
              class="w-100"
            >
              <el-option
                v-for="group in groups"
                :key="group.key"
                :label="group.name"
                :value="group.key"
              />
            </el-select>
          </el-form-item>
          <span>
            Nếu để trống hệ thống tự động hiển thị tât cả
          </span>
        </el-col>
        <el-col
:lg="24"
:span="24"
class="mb-xl"
>
          <el-form-item
prop="create_fields"
label="Trường tạo mới"
class="mb-s"
>
            <el-select
              v-model="form.create_fields"
              placeholder="Chọn trường"
              multiple
              cleable
              filterable
              class="w-100"
            >
              <el-option
                v-for="field in moduleFields"
                :key="field.key"
                :label="field.name"
                :value="field.key"
              />
            </el-select>
          </el-form-item>
          <span>
            Nếu để trống hệ thống tự động hiển thị 3 trường đầu tiên trong nhóm đã chọn
          </span>
        </el-col>
        <el-col
:lg="24"
:span="24"
>
          <el-form-item
prop="roles"
label="Quyền hạn">
            <el-select
              v-model="form.roles"
              placeholder="Chọn các quyền"
              multiple
              cleable
              filterable
              class="w-100"
            >
              <el-option
                v-for="role in roles"
                :key="role.id"
                :label="role.name"
                :value="role.id"
              />
            </el-select>
          </el-form-item>
          <span>
            Nếu để trống hệ thống tự động hiển thị cho tất cả các quyền
          </span>
        </el-col>
        <el-col
:lg="24"
:span="24"
>
          <el-form-item
prop="contracts"
label="Luồng tương ứng">
            <el-select
              v-model="form.contracts"
              placeholder="Chọn luồng"
              multiple
              cleable
              filterable
              class="w-100"
            >
              <el-option
                v-for="contract in contracts"
                :key="contract.id"
                :label="contract.name"
                :value="contract.id"
              />
            </el-select>
          </el-form-item>
          <span>
            Nếu để trống hệ thống tự động hiển thị cho tất cả các luồng
          </span>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import PATTERNS from "@/config/patterns.js";
import { notification } from "@/utils/common";

export default {
  name: "ModuleFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    modules: Array,
    groups: Array,
    roles: Array,
    fields: Array,
    contracts: Array,
  },
  data() {
    return {
      form: {
        key: this.item ? this.item.key : "",
        name: this.item ? this.item.name : "",
        order: this.item ? this.item.order : 0,
        icon: this.item ? this.item.icon : "",
        groups: this.item ? this.item.groups || [] : [],
        create_fields: this.item ? this.item.create_fields || [] : [],
        roles: this.item ? this.item.roles || [] : [],
        contracts: this.item ? this.item.contracts || [] : [],
      },
      callingAPI: false,
    };
  },
  computed: {
    allModuleKeys() {
      return (this.modules || [])
        .filter((c) => c.key !== this.item?.key)
        .map((c) => c.key);
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && this.allModuleKeys.includes(value.trim())) {
          callback(new Error("Mã module đã tồn tại"));
        } else {
          callback();
        }
      };
      return {
        key: [
          {
            required: true,
            message: "Mã module không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã module không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "Tên module không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        icon: [
          {
            required: true,
            message: "Icon module không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    isCreate() {
      return !this.item || !this.item.key;
    },
    moduleFields() {
      const groupFields = this.groups.filter((g) => this.form.groups.includes(g.key)).map((g) => g.fields || []).flat();
      if (this.form.groups.length > 0) {
        return this.fields.filter((f) => groupFields.includes(f.key))
      }
      return this.fields
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let modules = [];
          if (this.isCreate) {
            modules = [this.form, ...this.modules];
          } else {
            modules = this.modules.map((g) => {
              if (g.key === this.item.key) {
                return this.form;
              }
              return g;
            });
          }
          this.$emit("save", {
            payload: { modules },
            success: () => {
              notification(
                this,
                "success",
                this.isCreate ? "create" : "update",
                `module hiển thị`
              );
              this.$emit("close");
            },
            error: () => {
              notification(
                this,
                "error",
                this.isCreate ? "create" : "update",
                `module hiển thị`
              );
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
